import React, { useEffect, useState } from 'react'
import { MapContainer, Marker, Popup, TileLayer, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { useMediaQuery } from 'react-responsive';


function AddressAndCommunication() {
    const isMobile1200 = useMediaQuery({ query: '(max-width: 1200px)' });
    const isMobile1100 = useMediaQuery({ query: '(max-width: 1100px)' });
    const isMobile500 = useMediaQuery({ query: '(max-width: 500px)' });

    const [isActive , setIsActive] = useState(1)

  return (
    <>
    {
        !isMobile1200 ?
            <div className='c-addres-smap'>
                <img className='c-as-bg' src="image/back-address.jpg" alt="" />
                <div className='c-form' style={{right: "39%" , left:"0"}}>
                    {
                        isActive === 2 ? 
                        <ContactUs />
                        :
                        <BranchList />
                    }
                    <div className={`c-icons map ${isActive === 1 ? "activeForm" : ""} ${isMobile1200 ? isActive === 2 ? "handleTop1200" : "" : ""} `} onClick={() => setIsActive(1)} style={{right: "-9.9%" , left:"auto"}}>
                        <svg  className='icons'  viewBox="0 0 64 64" ><g id="Pin"><path d="m32 0a24.0319 24.0319 0 0 0 -24 24c0 17.23 22.36 38.81 23.31 39.72a.99.99 0 0 0 1.38 0c.95-.91 23.31-22.49 23.31-39.72a24.0319 24.0319 0 0 0 -24-24zm0 35a11 11 0 1 1 11-11 11.0066 11.0066 0 0 1 -11 11z"/></g></svg>
                    </div>
                    <div className={`c-icons commun ${isActive === 2 ? "activeForm" : ""} ${isMobile1200 ? isActive === 2 ? "handleTop1200" : "" : ""} `} onClick={() => setIsActive(2)} style={{right: "-9.9%" , left:"auto"}}>
                        <svg className='icons' xmlns="http://www.w3.org/2000/svg" id="Layer_3" height="512" viewBox="0 0 32 32" width="512" data-name="Layer 3"><path d="m21.386 10c-1.055-4.9-3.305-8-5.386-8s-4.331 3.1-5.386 8z"/><path d="m10 16a30.013 30.013 0 0 0 .267 4h11.466a30.013 30.013 0 0 0 .267-4 30.013 30.013 0 0 0 -.267-4h-11.466a30.013 30.013 0 0 0 -.267 4z"/><path d="m10.614 22c1.055 4.9 3.305 8 5.386 8s4.331-3.1 5.386-8z"/><path d="m23.434 10h6.3a15.058 15.058 0 0 0 -10.449-8.626c1.897 1.669 3.385 4.755 4.149 8.626z"/><path d="m30.453 12h-6.7a32.332 32.332 0 0 1 .247 4 32.332 32.332 0 0 1 -.248 4h6.7a14.9 14.9 0 0 0 0-8z"/><path d="m19.285 30.626a15.058 15.058 0 0 0 10.451-8.626h-6.3c-.766 3.871-2.254 6.957-4.151 8.626z"/><path d="m8.566 22h-6.3a15.058 15.058 0 0 0 10.451 8.626c-1.899-1.669-3.387-4.755-4.151-8.626z"/><path d="m12.715 1.374a15.058 15.058 0 0 0 -10.451 8.626h6.3c.766-3.871 2.254-6.957 4.151-8.626z"/><path d="m8 16a32.332 32.332 0 0 1 .248-4h-6.7a14.9 14.9 0 0 0 0 8h6.7a32.332 32.332 0 0 1 -.248-4z"/></svg>
                    </div>

                </div>
            </div>

        :
            <ResponsiveCommponent />
    }
        
    </>
  )
}

export default AddressAndCommunication

function ResponsiveCommponent(){
    const [isActive , setIsActive] = useState(1)

    return(
        <div style={{marginTop: "50px"}}>
            <div className='c-r-icons'>
                <div className={`r-icons ${isActive === 1 ? "activeForm" : ""}`}  onClick={() => setIsActive(1)}>
                <svg  className='icons'  viewBox="0 0 64 64" ><g id="Pin"><path d="m32 0a24.0319 24.0319 0 0 0 -24 24c0 17.23 22.36 38.81 23.31 39.72a.99.99 0 0 0 1.38 0c.95-.91 23.31-22.49 23.31-39.72a24.0319 24.0319 0 0 0 -24-24zm0 35a11 11 0 1 1 11-11 11.0066 11.0066 0 0 1 -11 11z"/></g></svg>
                </div>
                <div className={`r-icons ${isActive === 2 ? "activeForm" : ""}`}  onClick={() => setIsActive(2)}>
                    <svg className='icons' xmlns="http://www.w3.org/2000/svg" id="Layer_3" height="512" viewBox="0 0 32 32" width="512" data-name="Layer 3"><path d="m21.386 10c-1.055-4.9-3.305-8-5.386-8s-4.331 3.1-5.386 8z"/><path d="m10 16a30.013 30.013 0 0 0 .267 4h11.466a30.013 30.013 0 0 0 .267-4 30.013 30.013 0 0 0 -.267-4h-11.466a30.013 30.013 0 0 0 -.267 4z"/><path d="m10.614 22c1.055 4.9 3.305 8 5.386 8s4.331-3.1 5.386-8z"/><path d="m23.434 10h6.3a15.058 15.058 0 0 0 -10.449-8.626c1.897 1.669 3.385 4.755 4.149 8.626z"/><path d="m30.453 12h-6.7a32.332 32.332 0 0 1 .247 4 32.332 32.332 0 0 1 -.248 4h6.7a14.9 14.9 0 0 0 0-8z"/><path d="m19.285 30.626a15.058 15.058 0 0 0 10.451-8.626h-6.3c-.766 3.871-2.254 6.957-4.151 8.626z"/><path d="m8.566 22h-6.3a15.058 15.058 0 0 0 10.451 8.626c-1.899-1.669-3.387-4.755-4.151-8.626z"/><path d="m12.715 1.374a15.058 15.058 0 0 0 -10.451 8.626h6.3c.766-3.871 2.254-6.957 4.151-8.626z"/><path d="m8 16a32.332 32.332 0 0 1 .248-4h-6.7a14.9 14.9 0 0 0 0 8h6.7a32.332 32.332 0 0 1 -.248-4z"/></svg>
                </div>    
            </div>     

            <div>
                {
                isActive === 2 ? 
                <ContactUs />
                :
                <BranchList />
                }
            </div>

        </div>
    )
}

const branchesData = [
    { id: 3, email: 'pahlavan.tradegroup@gmail.com', address: 'مشهد, بلوار سجاد, بهارستان ۱۰, شماره ۴۵ ', phone: '051_3760201 / 051_37562740' , lat: "36.32151137621542" , lng :"59.55322301400884" },
];

function BranchList(){

    const [positionXMashhad , setPositionXMashhad] = useState(36.32151137621542)
    const [positionYMashhad , setPositionYMashhad] = useState(59.55322301400884)
    const Mashhad = [positionXMashhad , positionYMashhad]
  
    const [positionX , setPositionX] = useState(36.32151137621542)
    const [positionY , setPositionY] = useState(59.55322301400884)

    const [clickState , setclickState] = useState(false)
    
    const defaultMarkerIcon = new L.Icon({
        iconUrl: 'image/marker-icon-2x.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowUrl: 'image/marker-shadow.png',
        shadowSize: [41, 41]
    });

    function ChangeView({ center }) {
        const map = useMap();
        useEffect(() => {
          map.setView(center, 13); 
        }, [clickState]);
        return null;
      }

    return(
        <div className='c-communication' style={{direction: "rtl"}}>
            <div className='title-communication'>
                <h1> لیست شعب ما </h1>
                <p> لیست شعب و نمایندگی های ما در سراسر کشور را در این بخش بیابید  </p>
            </div>
            
            <div>
                <div className='c-branch'>
                    {
                        branchesData.map((item) => {
                            return(
                                <div className='branch-item' key={item.id}  onClick={() => setclickState(!clickState) } >
                                    <div>
                                        <p className='b-i-title'>آدرس: </p>
                                        <span className='b-i-desc'>{item.address}</span>
                                    </div>
                                    <div>
                                        <p className='b-i-title'>ایمیل: </p>
                                        <span className='b-i-desc'>{item.email}</span>
                                    </div>
                                    <div>
                                        <p className='b-i-title'>تلفن: </p>
                                        <span className='b-i-desc'>{item.phone}</span>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>

                <div className="c-Address-shobe" style={{justifyContent:'center'}}>
                    <MapContainer
                        center={[positionX, positionY]}
                        zoom={13}
                        style={{ height: '100%', width: '100%', borderRadius: '10px' }}
                        >
                        <ChangeView center={[positionX, positionY]} />
                        <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            attribution='&copy; OpenStreetMap contributors'
                        />

                        <Marker position={Mashhad}  icon={defaultMarkerIcon}>
                            <Popup> مشهد ، بلوار سجاد ، بهارستان 10،شماره45  </Popup>
                        </Marker>

                    </MapContainer>
                </div>
            </div>

        </div>
    )
}

function ContactUs(){
    return(
        <div className='c-communication' style={{direction: "rtl"}}>
            <div className='title-communication'>
                <h1> تماس با ما </h1>
                <p> لطفا اطلاعات خود را وارد کنید تا بتوانیم در اسرع وقت با شما تماس بگیریم   </p>
            </div>

            <div className='communication-form'>
                <div className='c-f-parent-inptu'>
                    <input className='c-f-input' type="text" placeholder='نام...'/>
                    <input className='c-f-input' type="text" placeholder='نام خانوادگی...'/>
                </div>
                <div className='c-f-parent-inptu'>
                    <input className='c-f-input' type="text" placeholder='ایمیل'/>
                    <input className='c-f-input' type="text" placeholder='تلفن'/>
                </div>
                <div className='c-m-textra-btn'>
                    <textarea name="" id=""></textarea>
                    <button> ارسال </button>
                </div>
            </div>
        </div>
    )
}



